import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { XCircleIcon16Solid } from "../../../../../icons2022/XCircleIcon/XCircleIcon16Solid";
import { XCircleIcon20Solid } from "../../../../../icons2022/XCircleIcon/XCircleIcon20Solid";
import { XCircleIcon24Solid } from "../../../../../icons2022/XCircleIcon/XCircleIcon24Solid";
export var ValidationErrorIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(XCircleIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(XCircleIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(XCircleIcon24Solid, null);
  }
}, 'ValidationErrorIcon');